<template>
   <!-- Columna principal con la tabla -->
      <v-col cols="12">
        
                           <!--  <v-btn
                                color="primary"
                                class="mr-4"
                                type="submit"
                                @click="exportToExcel"
                            >
                                Descargar como Excel
                            </v-btn> -->
                              <v-btn class="mr-4 gris_medio" type="submit" @click="exportToExcel">
                <v-icon left>mdi-file-excel</v-icon>  {{$t('resultados.descargar_excel')}}
                </v-btn>

      </v-col>
<div class="box">
    <v-row>

      <!-- Columna principal con la tabla -->
      <v-col cols="12">

    <v-typography variant="h1">
      {{$t('resultados.economicos')}} 
    </v-typography>
      </v-col>

    </v-row>

    <v-row>
    
      <v-col cols="12">

  <!--
  <v-data-table :items="items" :headers="headers" hide-default-footer class='row-height-50' height="400px"
    disable-pagination
  :items-per-page="-1"
  fixed-header>

<template v-slot:[`column.header`]="{ column }">
        <th
          :style="{ backgroundColor: column.color, width: column.width }"
        >
          {{ column.text }}
        </th>        
      </template>

      <template v-slot:item="{ item, columns }">
        <tr>
          <td
            v-for="(column, index) in columns"
            :key="index"
            :style="{ backgroundColor: column.color }"
          >
            {{ item[column.value] }}
          </td>
        </tr>
      </template>

      
      <template #bottom>
        <tr>
          <td><strong>Total</strong></td>
          <td v-for="(header, index) in headers.slice(1)" :key="index">
            <strong>{{ calcularTotal(header.value) }}</strong>
          </td>
        </tr>
      </template>

    </v-data-table>
    -->

    <v-data-table
      :headers="headers"
      :items="itemsConTotales"
      hide-default-footer
      class="row-height-50"
      height="550px"
      disable-pagination
      :items-per-page="-1"
      fixed-header
    >
      <!-- Personalización de cabecera -->
      <template v-slot:[`column.header`]="{ column }">
        <th :style="{ backgroundColor: column.color, width: column.width }">
          {{ column.text }}
        </th>
      </template>

      <!-- Filas de datos y fila de totales -->
      <template v-slot:item="{ item, columns }">
        <tr :class="{ 'total-row': item.isTotal }">
          <td
            v-for="(column, index) in columns"
            :key="index"
            :style="{ backgroundColor: column.color }"
          >
            {{ column.value === 'COST_PJEL' && !item.isTotal
              ? Number(item[column.value]).toFixed(4)
              : item[column.value] }}
          </td>
        </tr>
      </template>
          </v-data-table>


      </v-col>


    </v-row>


    <v-row>
      <!-- Columna de margen izquierda -->
      <v-col cols="0"></v-col>

     

      <!-- Columna de margen derecha -->
      <v-col cols="0"></v-col>
    </v-row>


</div>

</template>



<script>
import * as XLSX from 'xlsx';


export default {

  props: {
    items: Object,
  },
emits: ['precio-pool-ref', 'precio-pool-ref-ce'],
 components: {

  },

  data() {
    return {

    headers: [
      { title: 'Hora', value: 'FECHA_HORA', width: "1%" },
      { title: 'Periodo tarifario', value: 'TARIFA', width: "1%" },
      { title: 'Precio electricidad (€/MWh)', value: 'PCIO_EL', width: "1%" },
      { title: 'RO (€/MWh)', value: 'Ro', width: "1%" },
      { title: 'Precio gas (€/MWh)', value: 'PCIOGAS', width: "1%" },
      { title: 'Precio CO2 (€/Tn)', value: 'PCIOCO2', width: "1%" },
      { title: 'Ratio (E/G)', value: 'RATIO', width: "1%" },
      { title: 'Demanda (MW)', value: 'DEMV', width: "1%" },
      { title: 'Coste gas mercado motores de cogeneración (€)', value: 'COST_GMCMC', width: "1%" },
      { title: 'Coste gas mercado calderas de vapor (€)', value: 'COST_GMCCV', width: "1%" },
      { title: 'Coste swap de gas (€)', value: 'COST_SWAP', width: "1%" },
      { title: 'Peaje fijo de gas (€)', value: 'COST_PJGAS', width: "1%" },
      { title: 'Coste CO2 MC (€)', value: 'COST_CO2MC', width: "1%" },
      { title: 'Coste CO2 CV (€)', value: 'COST_CO2CV', width: "1%" },
      { title: 'Coste Electricidad CE (€)', value: 'COST_ELCE', width: "1%" },
      { title: 'Exceso potencia CE (€)', value: 'COST_EXCP', width: "1%" },
      { title: 'Coste Electricidad COM (€)', value: 'COST_ELCOM', width: "1%" },
      { title: 'Coste OyM MC (€)', value: 'COST_OYMMC', width: "1%" },
      { title: 'Peaje fijo de electricidad (€)', value: 'COST_PJEL', width: "1%" },
      { title: 'Coste alquiler compresores (€)', value: 'COST_ALCOM', width: "1%" },
      /* { title: 'Coste del contrato cerrado de electricidad (€)', value: 'COST_CONTEL', width: "1%" }, */
      { title: 'Coste swap de electricidad (€)', value: 'COST_SWAPE', width: "1%" },
      { title: 'Ingresos Electricidad MC (€)', value: 'ING_ELMC', width: "1%" },
      { title: 'Ingresos Ro MC (€)', value: 'ING_ELRo', width: "1%" },
      { title: 'Coste IVPEE (€)', value: 'COST_IVPEE', width: "1%" },
      { title: 'Balance Total (€)', value: 'COST_TOTAL', width: "1%" },
      { title: 'Balance de Referencia (€)', value: 'COST_REF', width: "1%" },
      { title: 'Balance de Referencia con CE (€)', value: 'COST_REFCE', width: "1%" },
      { title: 'Balance Óptimo (€)', value: 'COST_OPT', width: "1%" },
      { title: 'Ahorro (€)', value: 'AHORRO', width: "1%" },
      { title: 'Ahorro CE (€)', value: 'AHORRO_CE', width: "1%" },
      { title: 'Ahorro Óptimo (€)', value: 'AHORRO_OPT', width: "1%" },
      { title: 'Precio térmico Total (€/MWh)', value: 'PRC_TERM_TOTAL', width: "1%" },
      { title: 'Precio térmico Ref (€/MWh)', value: 'PRC_TERM_REF', width: "1%" },
      { title: 'Beneficio Bruto (€)', value: 'BENEFICIO_BRUTO', width: "1%" },
      { title: 'Coste MC (€/MWht)', value: 'CMED_MC', width: "1%" },
      { title: 'Coste CV (€/MWht)', value: 'CMED_CV', width: "1%" },
      { title: 'Coste CE (€/MWht)', value: 'CMED_CE', width: "1%" },
      { title: 'Pool REF MC (€/MWh)', value: 'PCEQ_MCCV', width: "1%" },
      { title: 'Pool REF CE (€/MWh)', value: 'PCEQ_CVCE', width: "1%" },


    ]



      
    };
  },

  mounted() {
   
  },

  computed: {
    itemsConTotales() {
      // Compatibilidad con simulaciones antiguas:
      // antiguas -> PCEQ_MCCE
      // nuevas   -> PCEQ_CVCE
      const itemsNormalizados = this.items.map(item => ({
        ...item,
        PCEQ_CVCE: item.PCEQ_CVCE ?? item.PCEQ_MCCE
      }));
      const totalRow = {
        FECHA_HORA: "Total",
        TARIFA: "N/A",
        
        // Suma de columnas
        PCIO_EL: "N/A",
        DEMV: this.items.reduce((acc, item) => acc + (item.DEMV || 0), 0).toFixed(1),
        COST_GMCMC: this.items.reduce((acc, item) => acc + (item.COST_GMCMC || 0), 0).toFixed(1),
        COST_GMCCV: this.items.reduce((acc, item) => acc + (item.COST_GMCCV || 0), 0).toFixed(1),
        COST_SWAP: this.items.reduce((acc, item) => acc + (item.COST_SWAP || 0), 0).toFixed(1),
        COST_PJGAS: this.items.reduce((acc, item) => acc + (item.COST_PJGAS || 0), 0).toFixed(1),
        COST_CO2MC: this.items.reduce((acc, item) => acc + (item.COST_CO2MC || 0), 0).toFixed(1),
        COST_CO2CV: this.items.reduce((acc, item) => acc + (item.COST_CO2CV || 0), 0).toFixed(1),
        COST_ELCE: this.items.reduce((acc, item) => acc + (item.COST_ELCE || 0), 0).toFixed(1),
        COST_EXCP: this.items.reduce((acc, item) => acc + (item.COST_EXCP || 0), 0).toFixed(1),
        COST_ELCOM: this.items.reduce((acc, item) => acc + (item.COST_ELCOM || 0), 0).toFixed(1),
        COST_OYMMC: this.items.reduce((acc, item) => acc + (item.COST_OYMMC || 0), 0).toFixed(1),
        COST_PJEL: this.items.reduce((acc, item) => acc + (item.COST_PJEL || 0), 0),
        COST_ALCOM: this.items.reduce((acc, item) => acc + (item.COST_ALCOM || 0), 0).toFixed(1),
        COST_CONTEL: this.items.reduce((acc, item) => acc + (item.COST_CONTEL || 0), 0).toFixed(1),
        COST_SWAPE: this.items.reduce((acc, item) => acc + (item.COST_SWAPE || 0), 0).toFixed(1),
        ING_ELMC: this.items.reduce((acc, item) => acc + (item.ING_ELMC || 0), 0).toFixed(1),
        ING_ELRo: this.items.reduce((acc, item) => acc + (item.ING_ELRo || 0), 0).toFixed(1),
        COST_TOTAL: this.items.reduce((acc, item) => acc + (item.COST_TOTAL || 0), 0).toFixed(1),
        COST_REF: this.items.reduce((acc, item) => acc + (item.COST_REF || 0), 0).toFixed(1),
        COST_REFCE: this.items.reduce((acc, item) => acc + (item.COST_REFCE || 0), 0).toFixed(1),
        COST_OPT: this.items.reduce((acc, item) => acc + (item.COST_OPT || 0), 0).toFixed(1),
        AHORRO: this.items.reduce((acc, item) => acc + (item.AHORRO || 0), 0).toFixed(1),
        AHORRO_CE: this.items.reduce((acc, item) => acc + (item.AHORRO_CE || 0), 0).toFixed(1),
        AHORRO_OPT: this.items.reduce((acc, item) => acc + (item.AHORRO_OPT || 0), 0).toFixed(1),
        PRC_TERM_TOTAL: (this.items.reduce((acc, item) => acc + (item.PRC_TERM_TOTAL || 0), 0) / this.items.length).toFixed(1),
        PRC_TERM_REF: (this.items.reduce((acc, item) => acc + (item.PRC_TERM_REF || 0), 0) / this.items.length).toFixed(1),
        BENEFICIO_BRUTO: this.items.reduce((acc, item) => acc + (item.BENEFICIO_BRUTO || 0), 0).toFixed(1),
        Ro: "N/A",
        PCIOGAS: "N/A",
        PCIOCO2: "N/A",
        RATIO: "N/A",
        COST_IVPEE: this.items.reduce((acc, item) => acc + (item.COST_IVPEE || 0), 0).toFixed(2),
        CMED_MC: "N/A",
        CMED_CV: "N/A",
        PCEQ_MCCV:"N/A",
        //PCEQ_MCCE:"N/A",
        PCEQ_CVCE:"N/A",
        CMED_CE: "N/A",
        

        // Media de columnas
        // Aquí puedes poner las columnas que deben tener la media
        MEDIA_DEMV: (this.items.reduce((acc, item) => acc + (item.DEMV || 0), 0) / this.items.length).toFixed(1),
        MEDIA_COST_GMCMC: (this.items.reduce((acc, item) => acc + (item.COST_GMCMC || 0), 0) / this.items.length).toFixed(1),
        // Puedes agregar otras medias aquí...
      };

      return [...itemsNormalizados, totalRow]; // Agregamos la fila total al final
    },
    maxPCEQ_MCCV() {
      if (!Array.isArray(this.items)) return null;

      const nums = this.items
        .filter(r => {
          const cv6 = Number(r?.PV_CVcv6) || 0;
          const cv7 = Number(r?.PV_CVcv7) || 0;
          const cv10 = Number(r?.PV_CVcv10) || 0;

          return cv6 > 0 || cv7 > 0 || cv10 > 0;
        })
        .map(r => Number(r?.PCEQ_MCCV))
        .filter(v => !Number.isNaN(v));

      return nums.length ? Math.max(...nums) : null;
    },
    maxPCEQ_CVCE() {
      if (!Array.isArray(this.items)) return null;

      const nums = this.items
        .filter(r => {
          const ce11 = Number(r?.PV_CEce1) || 0;
          const ce12 = Number(r?.PV_CEce2) || 0;

          return ce11 > 0 || ce12 > 0;
        })
        .map(r => Number(r?.PCEQ_CVCE ?? r?.PCEQ_MCCE))
        .filter(v => !Number.isNaN(v));

      return nums.length ? Math.max(...nums) : null;
    },

  },

  watch: {
    maxPCEQ_MCCV: {
      immediate: true,
      handler(n) {
        this.$emit('precio-pool-ref', n);
      }
    },
    maxPCEQ_CVCE: {
      immediate: true,
      handler(n) {
        this.$emit('precio-pool-ref-ce', n);
      }

}
},
methods: {
  normalizarNumeroExcel(valor, decimales = 2) {
    if (valor === "" || valor == null || valor === "-" || valor === "N/A") {
      return "";
    }

    if (typeof valor === "number") {
      if (!Number.isFinite(valor)) return "";
      return Number(valor.toFixed(decimales));
    }

    let texto = String(valor).trim();

    if (texto === "" || texto === "-" || texto === "N/A") return "";

    // Quitar espacios normales y espacios raros de Excel
    texto = texto.replace(/\s/g, "").replace(/\u00A0/g, "");

    // Corrige casos tipo "0," o "20,"
    texto = texto.replace(/[,.]$/, "");

    // Si tiene letras, unidades, símbolos, etc., no lo convertimos
    if (/[a-zA-ZáéíóúÁÉÍÓÚñÑ€%]/.test(texto)) return "";

    // Formato español: "1.234,56"
    if (texto.includes(".") && texto.includes(",")) {
      texto = texto.replace(/\./g, "").replace(",", ".");
    }
    // Formato español simple: "12,34"
    else if (texto.includes(",")) {
      texto = texto.replace(",", ".");
    }
    // Formato miles español sin decimales: "1.234"
    else if (/^-?\d{1,3}(\.\d{3})+$/.test(texto)) {
      texto = texto.replace(/\./g, "");
    }

    const numero = Number(texto);

    if (!Number.isFinite(numero)) return "";

    return Number(numero.toFixed(decimales));
  },

  obtenerFormatoNumeroExcel(valor, decimales = 2) {
    if (typeof valor !== "number" || !Number.isFinite(valor)) {
      return "#,##0";
    }

    const numeroRedondeado = Number(valor.toFixed(decimales));
    const tieneDecimales = !Number.isInteger(numeroRedondeado);

    if (!tieneDecimales) {
      return "#,##0";
    }

    const almohadillas = "#".repeat(decimales);
    return `#,##0.${almohadillas}`;
  },

  formatearValorExcel(header, valor) {
    if (valor === null || valor === undefined || valor === "" || valor === "N/A") {
      return valor ?? "";
    }

    if (header.value === "FECHA_HORA" || header.value === "TARIFA") {
      return valor;
    }

    if (header.value === "COST_PJEL") {
      const numero = this.normalizarNumeroExcel(valor, 4);
      return numero !== "" ? numero : valor;
    }

    const numero = this.normalizarNumeroExcel(valor, 2);
    return numero !== "" ? numero : valor;
  },

  aplicarFormatoCeldaExcelJS(cell, decimales = 2) {
    if (typeof cell.value !== "number") return;

    const numeroRedondeado = Number(cell.value.toFixed(decimales));
    cell.value = numeroRedondeado;

    cell.numFmt = this.obtenerFormatoNumeroExcel(numeroRedondeado, decimales);
  },

  agregarDatosAlWorkbook(sheet) {
    const headers = this.headers.map(h => h.title);

    const datos = this.itemsConTotales.map(item => {
      const row = [];

      this.headers.forEach(h => {
        row.push(this.formatearValorExcel(h, item[h.value]));
      });

      return row;
    });

    sheet.columns = headers.map(h => ({
      header: h,
      width: 25,
    }));

    datos.forEach(row => {
      const fila = sheet.addRow(row);

      fila.eachCell((cell, colNumber) => {
        const header = this.headers[colNumber - 1];

        if (!header) return;

        if (header.value === "COST_PJEL") {
          this.aplicarFormatoCeldaExcelJS(cell, 4);
        } else if (header.value !== "FECHA_HORA" && header.value !== "TARIFA") {
          this.aplicarFormatoCeldaExcelJS(cell, 2);
        }

        cell.alignment = {
          vertical: "middle",
          horizontal: "center"
        };
      });
    });
  },

  calcularTotal(campo) {
    return this.items.reduce((acc, item) => acc + (item[campo] || 0), 0);
  },

  exportToExcel() {
    const wb = XLSX.utils.book_new();

    const headerTitles = this.headers.map(header => header.title);

    const filteredItems = this.itemsConTotales.map(item => {
      const filteredItem = {};

      this.headers.forEach(header => {
        filteredItem[header.title] = this.formatearValorExcel(
          header,
          item[header.value]
        );
      });

      return filteredItem;
    });

    const ws = XLSX.utils.json_to_sheet(filteredItems, {
      header: headerTitles
    });

    const wsCols = headerTitles.map(() => ({ wch: 22 }));
    ws["!cols"] = wsCols;

    const range = XLSX.utils.decode_range(ws["!ref"]);

    for (let R = range.s.r + 1; R <= range.e.r; R++) {
      this.headers.forEach((header, index) => {
        const C = index;
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = ws[cellAddress];

        if (!cell || typeof cell.v !== "number") return;

        cell.t = "n";

        if (header.value === "COST_PJEL") {
          const numeroRedondeado = Number(cell.v.toFixed(4));
          cell.v = numeroRedondeado;
          cell.z = this.obtenerFormatoNumeroExcel(numeroRedondeado, 4);
        } else if (header.value !== "FECHA_HORA" && header.value !== "TARIFA") {
          const numeroRedondeado = Number(cell.v.toFixed(2));
          cell.v = numeroRedondeado;
          cell.z = this.obtenerFormatoNumeroExcel(numeroRedondeado, 2);
        }
      });
    }

    XLSX.utils.book_append_sheet(wb, ws, "Resultados económicos");

    XLSX.writeFile(wb, "resultados-economicos.xlsx");
  }
}
};
</script>










<style>

.total-row {
  font-weight: bold; /* Aplica negrita a la fila de totales */
}

.v-data-table.row-height-50 td
{
  height: 18px !important;
  font-size:8px

}

.v-data-table.row-height-50 th
{
  height: 18px !important;
  font-size:8px
}


.red-cell {
  background-color: red;
  color: white;
}

.green-cell {
  background-color: green;
  color: white;
}

.box {
    margin: 20px; /* Margen en los cuatro lados */
    padding: 10px;

  }


</style>
